import React from "react";
import { useContext, useEffect, useState } from "react";
import { ShowPageContext } from "../../../provider/MyContexts";
import PageLayout from "../components/PageLayout";
import PageContents from "./elements/pageContents/PageContentsV2";

export default function GeneratePage() {
  const { showPage, setShowPage } = useContext(ShowPageContext);

  const [activeStep, setActiveStep] = useState<number>(0);

  function handleNext() {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }

  function handleBack() {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }

  useEffect(() => {
    setActiveStep(0);
  }, [showPage]);

  if (showPage !== "generate") {
    return null;
  }

  return (
    <PageLayout>
      <PageContents
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        setShowPage={setShowPage}
      />
    </PageLayout>
  );
}
